import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const notificationSentV1Schema = eventEnvelopeSchema.extend({
  notificationId: z.string().min(1).max(256),
  channel: z.literal('in_app'),
  template: z.string().min(1).max(256),
  provider: z.string().min(1).max(256),
  userId: z.string().min(1).max(256).optional(),
});

export type NotificationSentV1 = z.infer<typeof notificationSentV1Schema>;

export const NOTIFICATION_SENT_V1_DETAIL_TYPE = 'notification.sent.v1' as const;
